import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import EnrollmentOverviewWidgetBody from './body';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

const EnrollmentOverview = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs(props);
  const configBuilder = (_state) => {
    return {
      remoteOptions: getRemoteConfigs(url, EnrollmentOverviewWidgetBody)
    };
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder);

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      { ...widgetConfig.remoteOptions }
      footerActions={ actions.footerActions }
    />
  );
};

export default EnrollmentOverview;